import React from 'react';

const PageSubTitle = ({ children }) => {
    return (
        <div className='mt-3 w-full flex flex-col items-center justify-center'>
            {children}
        </div>
    );
};

export default PageSubTitle;
